import React, { useContext } from 'react';
import { IModifierGroupContext, ModifierGroupContext } from '../../../modifierGroupState/modifierGroupContext';
import Text from 'components/Text/Text';
import { Item } from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

export const List: React.FC = () => {
	const { modifierGroups } = useContext<IModifierGroupContext>(ModifierGroupContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const articleNumberHeadingClasses = classNames(style.articleNumber, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="modifierGroupLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="numberOfRestaurantsLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={articleNumberHeadingClasses}
					translationNameSpace="listing"
					translationKey="articleNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{modifierGroups.modifierGroups.map((item, index) => (
				<Item data={item} key={item.id + 'list'} index={index} />
			))}
		</div>
	);
};
